/* eslint-disable import/no-unused-modules */
import { createContext, useContext } from 'react';

const LanguageContext = createContext();

export const useLanguageContext = () => useContext(LanguageContext);
export default LanguageContext;
